/* eslint-disable no-loss-of-precision */
import blank from '../../Blank/blankData'

import EaringsCircle from '../../Jewelry/EaringsCircle'
import EaringsLoop from '../../Jewelry/EaringsLoop'
import EaringsDangling from '../../Jewelry/EaringsDangling'
import EaringsPearl from '../../Jewelry/EaringsPearl'
import EaringsDiamond from '../../Jewelry/EaringsDiamond'
import EaringsSmallLoop from '../../Jewelry/EaringsSmallLoop'

const data = [
  blank,
  {
    id: 'EaringsCircle',
    svg: EaringsCircle,
    positioning: {
      pointNarrow: {
        y: 118.78416442871094,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 118.51924133300781,
        scaleX: 0.9,
      },
      pointWide: {
        y: 115.86097717285156,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 120.32322692871094,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 120.78976440429688,
        scaleX: 0.95,
      },
      roundWide: {
        y: 116.666259765625,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 121.953369140625,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 118.7449951171875,
        scaleX: 1,
      },
      squareWide: {
        y: 118.39320373535156,
        scaleX: 1.05,
      },
    },
  },
  {
    id: 'EaringsLoop',
    svg: EaringsLoop,
    positioning: {
      pointNarrow: {
        y: 119.07579040527344,
        scaleX: 0.82,
      },
      pointMedium: {
        y: 117.36610412597656,
        scaleX: 0.95,
      },
      pointWide: {
        y: 115.54901123046875,
        scaleX: 1,
      },
      roundNarrow: {
        y: 119.13865661621094,
        scaleX: 0.82,
      },
      roundMedium: {
        y: 118.70944213867188,
        scaleX: 1,
      },
      roundWide: {
        y: 116.834716796875,
        scaleX: 1,
      },
      squareNarrow: {
        y: 121.94889831542969,
        scaleX: 0.82,
      },
      squareMedium: {
        y: 118.67002868652344,
        scaleX: 1,
      },
      squareWide: {
        y: 116.93148803710938,
        scaleX: 1,
      },
    },
  },
  {
    id: 'EaringsDangling',
    svg: EaringsDangling,
    positioning: {
      pointNarrow: {
        y: 121.47575378417969,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 119.5186767578125,
        scaleX: 0.95,
      },
      pointWide: {
        y: 116.35020446777344,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 120.68980407714844,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 119.40615844726562,
        scaleX: 0.95,
      },
      roundWide: {
        y: 116.0860595703125,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 121.62062072753906,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 119.84323120117188,
        scaleX: 0.95,
      },
      squareWide: {
        y: 115.48237609863281,
        scaleX: 1.05,
      },
    },
  },
  {
    id: 'EaringsPearl',
    svg: EaringsPearl,
    positioning: {
      pointNarrow: {
        y: 120.88150024414062,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 117.94398498535156,
        scaleX: 0.9,
      },
      pointWide: {
        y: 114.59637451171875,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 119.86705017089844,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 119.60163879394531,
        scaleX: 0.95,
      },
      roundWide: {
        y: 115.78141784667969,
        scaleX: 1,
      },
      squareNarrow: {
        y: 123.30076599121094,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 119.07257080078125,
        scaleX: 0.95,
      },
      squareWide: {
        y: 116.367919921875,
        scaleX: 1,
      },
    },
  },
  {
    id: 'EaringsDiamond',
    svg: EaringsDiamond,
    positioning: {
      pointNarrow: {
        y: 120.26707458496094,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 119.33146667480469,
        scaleX: 0.9,
      },
      pointWide: {
        y: 115.96713256835938,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 120.78707885742188,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 120.35661315917969,
        scaleX: 0.95,
      },
      roundWide: {
        y: 117.95449829101562,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 122.43910217285156,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 119.91720581054688,
        scaleX: 0.95,
      },
      squareWide: {
        y: 118.46684265136719,
        scaleX: 1,
      },
    },
  },
  {
    id: 'EaringsSmallLoop',
    svg: EaringsSmallLoop,
    positioning: {
      pointNarrow: {
        y: 118.58929443359375,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 118.74966430664062,
        scaleX: 0.9,
      },
      pointWide: {
        y: 115.85748291015625,
        scaleX: 1,
      },
      roundNarrow: {
        y: 119.14326477050781,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 116.84553527832031,
        scaleX: 0.9,
      },
      roundWide: {
        y: 114.06761169433594,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 121.54692077636719,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 118.42422485351562,
        scaleX: 0.9,
      },
      squareWide: {
        y: 116.93745422363281,
        scaleX: 1.05,
      },
    },
  },
]

export default data
